"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchWalletDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchWalletDto extends cursor_pagination_1.CursorPaginationOptions {
    ownerId;
    walletId;
    flatten;
    /** Only wallets whose balance is above zero. Arrives as the string "true" in query strings. */
    positiveBalance;
}
exports.SearchWalletDto = SearchWalletDto;
